/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneAdunit as ResolvedStandaloneAdunit } from 'base/components/standalone/Adunit';

export const Adunit: typeof ResolvedStandaloneAdunit = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneAdunit {...props} />
        </ErrorBoundary>
    );
});

export type AdunitProps = PropsFromComponent<typeof Adunit>;

/** @deprecated Use slot architecture instead */
export const AdunitWith = (extras: DynamicStandaloneExtras): typeof Adunit => {
    return function Adunit(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Adunit');
        return <ResolvedStandaloneAdunit {...mergeProps({ options: { theme } }, props)} />;
    }
}